import { createStore } from './store';

export const AppStore = createStore({
  isDarkMode: true,
});

export const useAppStore = AppStore.useStore;
